import { render, staticRenderFns } from "./Shopline.vue?vue&type=template&id=c4b39afc&"
import script from "./Shopline.vue?vue&type=script&lang=js&"
export * from "./Shopline.vue?vue&type=script&lang=js&"
import style0 from "./Shopline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports